
import { defineComponent, PropType, computed } from "vue";
import { Form } from "vee-validate";
import InputsRenderer from "./InputsRenderer.vue";

export default defineComponent({
  name: "FormPanel",
  components: { Form, InputsRenderer },
  props: {
    routeKey: { type: String, required: true },
    id: { type: String, required: true },
    isPage: { type: Boolean, required: true },
    validationSchema: { type: Object as PropType<any>, required: true },
    inputs: { type: Array as PropType<any[]>, required: true },
    relationships: { type: Object as PropType<Record<string, any[]>>, required: false },
    values: { type: Object as PropType<Record<string, any>>, required: true },
  },
  emits: ["submit", "invalid", "invalid-submit", "prevent-enter", "update:values", "add-nested-row", "remove-nested-row", "add-tier", "remove-tier"],
  setup(props, { emit }) {
    const innerValues = computed({
      get: () => props.values,
      set: (v) => emit("update:values", v),
    });

    return { innerValues };
  },
});
